import React from 'react';
import Spinner from 'src/view/shared/Spinner';
import PresupuestoFormPage from '../form/PresupuestoFormPage';

function PresupuestoView(props) {
  const renderView = () => {
    const {record, drawer} = props;
    return <PresupuestoFormPage record={record} disabled={true} drawer={drawer} />;
  };

  const {record, loading} = props;

  if (loading || !record) {
    return <Spinner />;
  }

  return renderView();
}

export default PresupuestoView;
